/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState, useEffect } from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2,
} from "variables/charts.js";

import Header from "components/Headers/Header.js";

import toast, { Toaster } from "react-hot-toast";

const Index = (props) => {
  const [actualizarheader, setActualizarheader] = useState(false);
  const [activeNav, setActiveNav] = useState(1);
  const [chartExample1Data, setChartExample1Data] = useState("data1");

  const [link, setLink] = useState(null);
  const [suscriptores, setSuscriptores] = useState([]);

  const success_modificado = (text) => {
    toast.success(text);
  };

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const toggleNavs = (e, index) => {
    e.preventDefault();
    setActiveNav(index);
    setChartExample1Data("data" + index);
  };

  const obtenerlink = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/obtenerlink/`);
      if (!response.ok) {
        throw new Error("Error en la red");
      }
      const data = await response.json();
      if (data.message) {
        setLink(data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const obtenersuscriptores = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/suscriptores/`
      );
      if (!response.ok) {
        throw new Error("Error en la red");
      }
      const data = await response.json();
      if (data) {
        setSuscriptores(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const actualizarlink = () => {
    const data = {
      link: document.getElementById("input-link").value,
    };
    fetch(`${process.env.REACT_APP_API}/actualizarlink`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          success_modificado(result.message);
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    obtenerlink();
    obtenersuscriptores();
  }, []);

  return (
    <>
      <Header act={actualizarheader} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="8">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Transmisión en Vivo</h3>
                  </div>
                  <div className="col text-right">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={actualizarlink}
                      size="sm"
                    >
                      Actualizar Link
                    </Button>
                  </div>
                </Row>
              </CardHeader>

              <div className="pl-lg-4 pr-4">
                <Row>
                  <Col md="12">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="input-address"
                      >
                        Link de Youtube o Facebook
                      </label>
                      <Input
                        className="form-control-alternative"
                        defaultValue={link !== null ? link : ""}
                        id="input-link"
                        placeholder="URL Link EN VIVO"
                        type="text"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Suscriptores</h3>
                  </div>
                  <div className="col text-right">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      Ver todos
                    </Button>
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Ultimos 10 Suscriptores</th>
                  </tr>
                </thead>
                <tbody>
                  {suscriptores.map((val, key) => {
                    return (
                      <tr>
                        <th scope="row">{val.Correo}</th>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
      <Toaster />
    </>
  );
};

export default Index;
